import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchUpdateRole } from "./rolebaseAPI";
import swal from 'sweetalert';
export interface UpdateRoleState {
  updateRole: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: UpdateRoleState = {
    updateRole: [],
  status: "idle",
};

export const GetUpdateRole = createAsyncThunk(
  "UpdateRole/fetchUpdateRole",
  async (data:any) => {
    const response = await fetchUpdateRole(data);
    return response;
  }
);

export const UpdateRoleSlice = createSlice({
  name: "UpdateRole",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUpdateRole.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUpdateRole.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetUpdateRole.fulfilled, (state, action) => {
        state.status = "idle";
        state.updateRole = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = UpdateRoleSlice.actions;

export const selectUpdateRole = (state: RootState) => {
  return state.UpdateRole.updateRole;
};

export default UpdateRoleSlice.reducer;
